package floris.graphics.models.dto.requests.project

import floris.graphics.extensions.isValidUrl
import floris.graphics.extensions.isYoutubeOrVimeoUrl
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InsertProject(
    val title: String,
    val subtitle: String? = null,
    val content: String? = null,
    val categories: List<String>? = null,
    val techstacks: List<String>? = null,
    @SerialName("video_url")
    val videoUrl: String,
    @SerialName("client_id")
    val clientId: String? = null,
    @SerialName("agency_id")
    val agencyId: String? = null,
    @SerialName("design_id")
    val designId: String? = null,
    @SerialName("animator_id")
    val animatorId: String? = null
) {

    val isValid get() = title.isNotEmpty() && categories.isNullOrEmpty().not() && techstacks.isNullOrEmpty().not() //&& (videoUrl.isValidUrl() && videoUrl.isYoutubeOrVimeoUrl())
}
